import { withNewLines } from '@/lib/newline'
import React from 'react'
import './blockLayout.css'
import { cx } from '@monorepo/helper/cx'

export type BlockThemeColor = 'teal' | 'yellow' | 'blue' | 'gray'

export type BlockLayoutName = 'default' | 'narrow'

type BlockTitleProps = {
  title?: string
  intro?: string
}

type BlockLayoutProps = BlockTitleProps & {
  color?: BlockThemeColor
  layout?: BlockLayoutName
  children?: React.ReactNode
  className?: string
}

const BlockTitle = ({ title, intro }: BlockTitleProps) => {
  if (!title && !intro) return null
  return (
    <div className="mx-auto mb-6 px-6 md:max-w-screen-sm lg:max-w-screen-md xl:max-w-screen-lg">
      <h1 className="xs:text-4xl color-secondary mx-auto mb-4 max-w-2xl text-3xl sm:text-5xl md:text-6xl">
        {withNewLines(title)}
      </h1>
      <p className="xs:text-xl color-primary mx-auto max-w-2xl text-lg leading-6 sm:text-2xl">
        {intro}
      </p>
    </div>
  )
}

const BlockLayout = ({
  title,
  intro,
  color = 'teal',
  layout = 'default',
  children,
  className,
}: BlockLayoutProps) => {
  return (
    <div
      className={cx(
        `block-layout-${layout} block-theme-${color} xs:p-5 p-3 text-center sm:p-16 md:py-20`,
        className,
      )}
    >
      <BlockTitle title={title} intro={intro} />
      <div>{children}</div>
    </div>
  )
}

export default BlockLayout
